import { Check, AlertTriangle, FileText } from 'lucide-react'

export default function LegalCompliance({ items }) {
  const hasVerified = items.some((i) => i.status === 'ok')

  return (
    <div className="surface p-5">
      <h3 className="text-sm font-semibold text-ink mb-4">Legal Compliance Summary</h3>
      {!hasVerified && items.length === 0 ? (
        <div className="flex flex-col items-center text-center py-6 px-4">
          <FileText size={28} className="text-neutral-300 mb-3" />
          <p className="text-xs text-muted leading-relaxed max-w-xs">
            No verified compliance documents yet. Upload your company documents under Governance &rarr; Legal to automatically populate your compliance score and summary here.
          </p>
        </div>
      ) : (
        <ul className="space-y-2.5">
          {items.map((i) => (
            <li key={i.id} className="flex items-start gap-2 text-sm">
              {i.status === 'ok' ? (
                <Check size={15} className="text-emerald-600 mt-0.5 shrink-0" />
              ) : (
                <AlertTriangle size={15} className="text-amber-600 mt-0.5 shrink-0" />
              )}
              <span className="text-ink">
                <span className="font-medium">{i.label}</span>
                {i.value && (
                  <span className={`font-mono ml-2 text-xs ${i.status === 'warn' ? 'text-amber-700' : 'text-muted'}`}>
                    {i.value}
                  </span>
                )}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
